import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";

const ConfirmationModal = ({ 
  confirm_modal, 
  close_confirmModal, 
  title,
  bodyContent,
  cancelText,
  confirmText,
  handleConfirmDelete,
  loading
   

}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  

  return (
    <Modal isOpen={confirm_modal} centered={true} className="contact_modal_custom">
      <ModalHeader
        toggle={close_confirmModal}
        style={{
          backgroundColor: "#0F528D",
          paddingTop: "0.75rem",
          paddingBottom: "0.75rem",
        }}
      >
        <span className="fs-16 contact_note_header ">{title}</span>
      </ModalHeader>
      <ModalBody className="">
        <div className="">
          <div className="fs-16 text-dark fw-medium centerContent">
          {bodyContent}
          </div>
          <div className="hstack gap-4 centerContent mt-3">
            <button
             type="button" 
             className="btn btn-soft-secondary"
             onClick={close_confirmModal}
             >
              {cancelText}
            </button>
            <button
             type="button" 
             className="btn btn-primary"
             onClick={handleConfirmDelete}
             style={{
              minWidth:"80px"
             }}
             disabled={loading}
             >
              {loading? <Spinner size="sm" />  : confirmText}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;
